module.exports = __webpack_public_path__ + "img/aws.6ec9ae58.png";